import { RiskForecastGraphs } from 'features/RiskManagement/Components/Graphs/Implementations/RiskForecastGraphs'

interface IGraphTypeToggle {
  graphType: RiskForecastGraphs
  setGraphType: (value: RiskForecastGraphs) => void
}

const GraphTypeToggle = ({ graphType, setGraphType }: IGraphTypeToggle) => {
  const activeClasses = [
    'px-3 py-2 rounded-l-sm',
    'bg-blue-lighthouse-500 bg-opacity-30',
    'font-medium text-sm',
    'leading-none'
  ].join(' ')

  const inactiveClasses = [
    'px-3 py-2 text-gray-500',
    'bg-blue-lighthouse-500 bg-opacity-10',
    'font-medium text-sm',
    'rounded-r-sm leading-none'
  ].join(' ')

  return (
    <div className='pl-4'>
      <button
        className={
          graphType === RiskForecastGraphs.ByThreat
            ? activeClasses
            : inactiveClasses
        }
        onClick={() => setGraphType(RiskForecastGraphs.ByThreat)}
      >
        By Threat
      </button>
      <button
        className={
          graphType === RiskForecastGraphs.Total
            ? activeClasses
            : inactiveClasses
        }
        onClick={() => setGraphType(RiskForecastGraphs.Total)}
      >
        Total
      </button>
    </div>
  )
}

export default GraphTypeToggle
